<template>

    <transition>
        <div class="fixed w-full h-screen inset-0 bg-black/30 flex justify-center items-center z-50">
            <div class=" w-full h-1/2 flex flex-col justify-center p-3 items-center space-y-5">
                <div class="flex justify-center space-x-2 mt-3">
                    <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-0"></span>
                    <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-150"></span>
                    <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-300"></span>
                </div>


            </div>
        </div>
    </transition>

</template>

<style scoped>
@keyframes bounce-wave {

    0%,
    80%,
    100% {
        transform: translateY(0);
    }

    40% {
        transform: translateY(-8px);
    }
}

.animate-bounce-wave {
    animation: bounce-wave 1.2s infinite ease-in-out;
}

.delay-0 {
    animation-delay: 0s;
}

.delay-150 {
    animation-delay: 0.15s;
}

.delay-300 {
    animation-delay: 0.3s;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Remove arrows for Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>
